import { getFetch, postFetch, putFetch, deleteFetch } from '../utils/fetch';
import { ENVIRONMENT_PROTECT_WORK } from './config';

export function getList(query) {
  return getFetch(`${ENVIRONMENT_PROTECT_WORK()}`, query);
}

export function getOne(_id) {
  return getFetch(`${ENVIRONMENT_PROTECT_WORK()}/${_id}`);
}

export function updateOne(_id, data = {}) {
  return putFetch(`${ENVIRONMENT_PROTECT_WORK()}/${_id}`, data);
}

export function deleteOne(_id) {
  return deleteFetch(`${ENVIRONMENT_PROTECT_WORK()}/${_id}`);
}

export function create(obj) {
  return postFetch(`${ENVIRONMENT_PROTECT_WORK()}`, obj);
}

export function getSearchList(query) {
  return getFetch(`${ENVIRONMENT_PROTECT_WORK()}`, {
    search: query,
    field: ['FacilityNameFull'],
    page: 1,
    itemPerPage: 10,
  });
}

export function getAll() {
  return getFetch(`${ENVIRONMENT_PROTECT_WORK()}/getAll`);
}

export function exportData(query) {
  return getFetch(`${ENVIRONMENT_PROTECT_WORK()}/export`, {
    ...query,
  });
}



// WEBPACK FOOTER //
// ./src/api/environmentProtectionWorkApi.js